import { globalStyles } from "@client/shared/constants";
const { display, background, flex, text } = globalStyles;

const styles = {
  drawerClose: {
    padding: "10px",
    ...background.color.primary.dark,
    ...flex.justify.between,
    maxWidth: "68px",
    cursor: "pointer",
  },
  content: {
    marginLeft: "75px",
  },
  drawerOpen: {
    padding: "10px",
    width: "220px",
    ...background.color.primary.dark,
    ...flex.justify.between,
    zIndex: (theme) => theme.zIndex.drawer + 2,
    cursor: "pointer",
  },
  iconContainer: {
    width: "100%",
    ...text.align.center,
  },
  container: {
    width: "100%",
    flexDirection: "column",
    ...display.flex,
    ...flex.align.center,
  },
  drawerList: {
    ...display.flex,
    flexDirection: "column",
    marginTop: "14px",
    // justifyContent: "center",
    // paddingLeft: '5px',
  },
  btnContainer: {
    display: "flex",
    justifyContent: "start",
  },
  drawerButtonActive: {
    backgroundColor: "white",
    padding: "12px 26px 12px 26px",
    marginTop: "16px",
    "&:hover": {
      backgroundColor: "white !important",
    },
    minWidth: "150px",
    justifyContent: "start",
  },
  drawerButtonClose: {
    backgroundColor: "white",
    minWidth: "40px",
    minHeight: "40px",
    margin: "8px",
    "&:hover": {
      backgroundColor: "white !important",
    },
  },
  drawerButton: {
    marginTop: "16px",
    color: "white",
  },

  drawerButtonInActive: {
    minWidth: "150px",
    padding: "12px 26px 12px 26px",
    marginTop: "16px",
    color: "white",
    justifyContent: "start",
  },
  rcLogo: {
    height: "28px",
    width: "140px",
  },
  logo: {
    width: "28px",
    height: "28px",
  },
  rIcon: {
    pointerEvents: "none",
  },
};

export default styles;
